const getDeviceChannel = () => {
  const nav = globalThis?.navigator
  if (!nav) return 'desktop'
  const ua = (nav.userAgent || '').toLowerCase()
  const isMobile = /iphone|ipod|android|blackberry|opera mini|iemobile|mobile/i.test(ua)
  const isTablet = /ipad|android(?!.*mobile)|tablet/i.test(ua)

  if (isTablet) return 'tablet'
  if (isMobile) return 'mobile'
  return 'desktop'
}

export const collectDeviceInformation = () => {
  const screen = globalThis?.screen ?? {}
  const nav = globalThis?.navigator ?? {}
  
  return {
    http_color_depth: (screen.colorDepth || 0).toString(),
    http_java_enabled: nav.javaEnabled?.()?.toString() ?? 'false',
    http_java_script_enabled: 'true',
    http_browser_language: nav.language || nav.userLanguage || 'unknown',
    http_screen_height: (screen.height || 0).toString(),
    http_screen_width: (screen.width || 0).toString(),
    http_time_difference: new Date().getTimezoneOffset().toString(),
    user_agent_browser_value: nav.userAgent || '',
    device_channel: getDeviceChannel(),
  }
}

